// Small presentational component that renders a question/label for a form
// field. It prefers the `text` prop but will render `children` when `text`
// is not provided.
import React from "react";
import { Typography } from "@mui/material";

const UI = {
  // Color used for the question text
  textDark: "#111827",
};

/**
 * FormQuestion
 * Props:
 * - text: optional string to display as the question/label
 * - children: fallback content to render when `text` is not provided
 *
 * This component is intentionally simple and purely presentational.
 */
export default function FormQuestion({ children, text }) {
  return (
    <Typography variant="h6" sx={{ fontWeight: 500, color: UI.textDark }}>
      {text || children}
    </Typography>
  );
}
